import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="container-custom">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3 uppercase tracking-wide">
            Product Categories
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Browse Products By Category
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Explore our organized product categories below. Each link takes you directly to the curated Superbuy Sheet collection for that category on our main website.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2.5 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-accent-50 border border-background-200/70 hover:border-accent-300 transition-all duration-200 cursor-pointer"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-background-200/70 group-hover:bg-accent-100 transition-colors">
                <i className={`${cat.icon} text-lg text-foreground-700 group-hover:text-accent-700`}></i>
              </span>
              <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-foreground-900 text-center whitespace-nowrap leading-tight">
                {cat.name}
              </span>
              <span className="text-[10px] text-foreground-500 text-center leading-snug hidden md:block">
                {cat.description.length > 60 ? cat.description.slice(0, 57) + '...' : cat.description}
              </span>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}